<template>
    <div style="padding: 15px;" v-if="lang">
    <md-layout md-gutter class="register-doctor main--content">
        <div class="col-md-2 col-sm-12 col-xs-12 no-padder">
            <div class="profile-image">
                <img :src="profile_image" class="img-responsive img-rounded">
                <div @click="uploadAvatarIcon" class="camera_upload">
                    <md-icon>photo_camera</md-icon>
                </div>
            </div>
            <span class="md-error" style="width: 100%;display: block;text-align: center;margin-top: 20px;color: red;">{{ errors.hasOwnProperty('formAvatar') && errors.formAvatar.length > 3 ? errors.formAvatar : '' }}</span>
            <form id="formAvatar" style="display:none;" method="POST" enctype="multipart/form-data">
                <input id="fileAvatar" type="file" name="avatar"  @change="onAvatarChange">
                <button type="submit">{{translate.pages.profile_doctor['avatar-btn']}}</button>
            </form>
        </div>
        <div class="col-md-10 col-sm-12 col-xs-12 no-padder" v-if="doctor.user">
            <form novalidate @submit.stop.prevent="submit">
                <div style="padding: 0">
                    <div class="col-md-6">
                        <md-input-container :class="{ 'md-input-invalid' : errors.hasOwnProperty('code') }">
                            <label>{{translate.pages.profile_doctor.fields.code}}</label>
                            <md-input v-model="doctor.code" disabled></md-input>
                            <span class="md-error">{{ errors.hasOwnProperty('code') ? errors.code[0] : '' }}</span>
                        </md-input-container>
                    </div>
                    <div class="col-md-6">
                        <md-input-container :class="{ 'md-input-invalid' : errors.hasOwnProperty('name') }">
                            <label>{{translate.pages.profile_doctor.fields.name}}</label>
                            <md-input v-model="doctor.name" required></md-input>
                            <span class="md-error">{{ errors.hasOwnProperty('name') ? errors.name[0] : '' }}</span>
                        </md-input-container>
                    </div>
                    <div class="col-md-6" v-if="doctor.is_institution !== 1">
                        <md-input-container :class="{ 'md-input-invalid' : errors.hasOwnProperty('lastname') }">
                            <label>{{translate.pages.profile_doctor.fields.lastname}}</label>
                            <md-input v-model="doctor.lastname"></md-input>
                            <span class="md-error">{{ errors.hasOwnProperty('lastname') ? errors.lastname[0] : '' }}</span>
                        </md-input-container>
                    </div>
                    <div class="col-md-6" v-if="doctor.is_institution !== 1">
                        <md-input-container :class="{ 'md-input-invalid' : errors.hasOwnProperty('lastname2') }">
                            <label>{{translate.pages.profile_doctor.fields.lastname2}}</label>
                            <md-input v-model="doctor.lastname2" ></md-input>
                            <span class="md-error">{{ errors.hasOwnProperty('lastname2') ? errors.lastname2[0] : '' }}</span>
                        </md-input-container>
                    </div>
                    <div class="col-md-6">
                        <md-input-container :class="{ 'md-input-invalid' : errors.hasOwnProperty('email') }">
                            <label>{{translate.pages.profile_doctor.fields.email}}</label>
                            <md-input v-model="doctor.email" disabled></md-input>
                            <span class="md-error">{{ errors.hasOwnProperty('email') ? errors.email[0] : '' }}</span>
                        </md-input-container>
                    </div>
                    <div class="col-md-6">
                        <md-input-container :class="{ 'md-input-invalid' : errors.hasOwnProperty('phone') }">
                            <label>{{translate.pages.profile_doctor.fields.phone}}</label>
                            <md-input v-model="doctor.phone" required></md-input>
                            <span class="md-error">{{ errors.hasOwnProperty('phone') ? errors.code[0] : '' }}</span>
                        </md-input-container>
                    </div>
                    <div style="background: #fafafa;">
                    <div class="col-md-6" style="background: #fafafa;"  v-if="doctor.is_institution == 1">
                    <label style="color: #959ea6 !important;    font-size: 12px;">Provincia</label>
                        <vue-select
                            :options="regions"
                            placeholder="Provincia"
                            :on-change="changeRegion"
                            v-model="doctor.region.label"
                            style=""
                            >
                            <span slot="no-options">No se encontraron resultados.</span>
                        </vue-select>

                        <span class="md-error">{{ errors.hasOwnProperty('region_id') ? errors.region_id : '' }}</span>
                    </div>
                    <div class="col-md-6" style="background: #fafafa;" v-if="doctor.is_institution == 1">
                    <label style="color: #959ea6 !important;    font-size: 12px;">Comuna</label>
                        <vue-select
                            :options="cities"
                            placeholder="Comuna"
                            :on-change="changeCity"
                            v-model="doctor.city.label"
                            >
                            <span slot="no-options">No se encontraron resultados.</span>
                        </vue-select>
                        <span class="md-error">{{ errors.hasOwnProperty('comunity') ? errors.comunity : '' }}</span>
                    </div>
                    <div class="col-md-6" style="background: #fafafa;"  v-if="doctor.is_institution == 1">
                        <md-input-container :class="{ 'md-input-invalid' : errors.hasOwnProperty('street') }">
                            <label>{{translate.pages.profile_doctor.fields.street}}</label>
                            <md-input v-model="doctor.street"></md-input>
                            <span class="md-error">{{ errors.hasOwnProperty('street') ? errors.street : '' }}</span>
                        </md-input-container>
                    </div>
                    <div class="col-md-6" style="background: #fafafa;"  v-if="doctor.is_institution == 1">
                        <md-input-container :class="{ 'md-input-invalid' : errors.hasOwnProperty('number') }">
                            <label>{{translate.pages.profile_doctor.fields.number}}</label>
                            <md-input v-model="doctor.number"></md-input>
                            <span class="md-error">{{ errors.hasOwnProperty('number') ? errors.number : '' }}</span>
                        </md-input-container>
                    </div>
                    </div>
                    <div class="spacer"></div>
                    <div class="profile--check">
                        <div class="col-md-6 mar-top-1">
                            <md-input-container style="margin: 0 !important;">
                                <md-input type="text"
                                v-model="filterSpecialities"
                                placeholder="Buscar Especialidad..."
                                ></md-input>
                            </md-input-container>
                            <div class="multiple checkbox-list">
                                <p class="title">{{translate.pages.profile_doctor.fields.specialities}}</p>
                                <div class="select">
                                    <md-checkbox class="option md-primary" v-for="speciality in filteredSpecialities" :key="speciality.id" @change="onChosen($event,speciality.id)" v-model="speciality.checked">{{ speciality.name }}</md-checkbox>
                                </div>
                            </div>
                            <label class="subtitle" :class="{ error: errors.specialities.invalid }">{{translate.pages.profile_doctor.fields.select_specialties}}</label>
                        </div>
                        <div class="col-md-6 checkbox-list checkbox-options">
                            <div >
                                <md-checkbox id="notification_appointment" md-theme="green" class="md-primary" name="notification_appointment" v-model="doctor.notification_appointment">{{translate.pages.profile_doctor.fields.notification_appointment}}</md-checkbox>
                            </div>
                            <div >
                                <md-checkbox id="notification_mail" md-theme="green" class="md-primary" name="notification_mail" v-model="doctor.notification_mail">{{translate.pages.profile_doctor.fields.notification_mail}}</md-checkbox>
                            </div>
                            <div >
                                <md-checkbox id="notification_sms" md-theme="green" class="md-primary" name="notification_sms" v-model="doctor.notification_sms">
                                    {{translate.pages.profile_doctor.fields.notification_sms}}
                                    ({{ doctor.user.sms_used }} / {{ doctor.user.plan.max_sms }})
                                </md-checkbox>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                    <div class="col-md-6">
                        <md-input-container >
                            <label>{{translate.pages.profile_doctor.fields.password}}</label>
                            <md-input type="password" v-model="doctor.password" required></md-input>
                        </md-input-container>
                        <span class="md-error">{{ errors.hasOwnProperty('password') ? errors.password[0] : '' }}</span>
                    </div>
                    <div class="col-md-6">
                        <md-input-container >
                            <label>{{translate.pages.profile_doctor.fields.confirm_password}}</label>
                            <md-input type="password" v-model="doctor.password_confirmation" required></md-input>
                            <span class="md-error">{{ errors.hasOwnProperty('password_confirmation') ? errors.password_confirmation[0] : '' }}</span>
                        </md-input-container>
                    </div>
                    <div class="clearfix"></div>
                    <md-button v-if="doctor.code != '11111111-1'" type="submit" class="md-raised md-primary md-size margin-t btn--blue" :disabled="process">{{translate.pages.profile_doctor.save_changes_btn}}</md-button>
                </div>
            </form>
            <md-dialog md-open-from="#custom" md-close-to="#custom" ref="dialog1">
                <md-dialog-content>{{ alert.msg }}</md-dialog-content>
                <md-dialog-actions>
                    <md-button class="md-primary" @click.native="closeDialog('dialog1')">{{translate.pages.profile_doctor.close_dialog}}</md-button>
                </md-dialog-actions>
            </md-dialog>

            <div class="clearfix"></div>
            <div class="col-md-12 col-xs-12 col-md-12">
                <h1>Sincronizacion con Facebook</h1>
                <div style="height: 90px !important;
                background: #e84949;
                color: white;
                padding: 20px;
                border-radius: 5px;
                text-align: justify;" class="alert alert-danger" v-if="FacebookSyncStatus == 4">
                        Ocurrio un error en la sincronizacion, recuerde que todos los permisos solicitados son necesarios para la integracion
                    </div>

                    <div style="height: 110px !important;
                    background: #8bc34a;
                    color: white;
                    padding: 20px;
                    border-radius: 5px;
                    text-align: justify;" class="alert alert-success" v-if="fbStatus == 3">
                        Ya sincronizo Agenda Medica ONLINE con FACEBOOK en su pagina: <b>{{fbPageData.name}}</b><br>
                        <md-button @click.native="FacebookRemoveTab()" class="md-raised">Desincronizar</md-button>
                    </div>
            <fb-signin-button
            v-if="fbStatus == 0"
            :params="fbSignInParams"
            @success="onSignInSuccess"
            @error="onSignInError">
            <md-icon>sync</md-icon> Sincronizar con Facebook
          </fb-signin-button>
          <div v-if="fbStatus == 1 || fbStatus == 2" class="fbintegration">
              <h5>Seleccione en que Pagina integrar:</h5>
          <md-list>
                <md-list-item v-for="row in fbPages" :key="row.id" @click="FacebookSelectPage(row)">
                  <span>{{row.name}}</span>
                </md-list-item>
          </md-list>
        </div>
          <md-button v-if="fbStatus == 2" @click.native="FacebookCreateTab()" class="md-raised md-primary md-size margin-t btn--blue">Integrar en: {{fbPageData.name}}</md-button>
          <br>
          <br>
          <br>
          <br>
          <br>
          <br>
            </div>
        </div>
    </md-layout>
    </div>
</template>
<script>
    var language = window.navigator.userLanguage || window.navigator.language;
    import { login, doctor, public_api } from '../../config/api.js';
    import vueSelect from "vue-select";
    //console.log(language);
    export default {
        components: {vueSelect},
        data() {
            return {
                filterSpecialities: "",
                appID: '1954146001278287',
                fbSignInParams: {scope: 'manage_pages'},
                fbLoged: false,
                fbPages: [],
                fbStatus: 0,
                fbPageData: {},
                fbWorking: false,
                fbSynced: false,

                process: false,
                language: 'es',
                alert: {
                    msg : '',
                },
                doctor : {
                    code : '',
                    name : '',
                    lastname : '',
                    lastname2 : '',
                    email : '',
                    phone : '',
                    password : '',
                    password_confirmation : '',
                    notification_appointment : false,
                    notification_mail : false,
                    notification_sms : false,
                    type: 'doctor',
                    specialities: [],
                    region: {label:'',value:''},
                    city: {label:'',value:''}
                },
                specialities: [],
                regions: [],
                cities: [],
                profile_image: 'https://api.agendaenlinea.cl/image/default_avatar.png',
                data: {
                    listspecialities : [],
                    confirmation : {
                        isSuccess : false,
                        isError : false,
                    },
                },
                errors: {
                    code                  : "",
                    name                  : "",
                    lastname              : "",
                    lastname2             : "",
                    email                 : "",
                    phone                 : "",
                    password              : "",
                    password_confirmation : "",
                    specialities          : "",
                    formAvatar            : "",
                },
                route: {
                    doctor: doctor,
                }
            }
        },
        created(){
            self = this;
            setTimeout(function(){
                // Login facebook status
                FB.getLoginStatus(function (res) {
                    if(res.status == "connected"){
                        self.fbLoged = true;
                        if(self.fbStatus != 3){
                            self.fbStatus = 1;
                        }
                        self.FacebookGetPages();
                    }
                })
            }, 1000);
            // Get Profile
            this.$http.get('/doctor/me', {
                    headers: {
                        Authorization : 'Bearer '+ this.$auth.getToken(),
                    }
                }).then(response => {
                    if(response.data.status == "OK"){
                        let data = response.data.data;
                        self.fbSynced = true;
                        if(data.facebook_id && data.facebook_token){
                            self.fbPageData = {
                                id: data.facebook_id,
                                token: data.facebook_token,
                                name: data.facebook_name
                            }
                            self.fbStatus = 3;
                        }
                        data.region = {'label':'','value':''};
                        data.city = {'label':'','value':''};
                        self.doctor = data;
                        if(self.doctor.image)
                        {
                            self.profile_image = self.doctor.image;
                        }else{
                            this.profile_image = 'https://api.agendaenlinea.cl/image/default_avatar.png';
                        }
                        if(self.doctor.is_institution){
                            var country = { "country": self.$route.params.country.toUpperCase() };
                            self.$http.post(doctor.api.regions, country, {
                                        headers: {
                                            Authorization : 'Bearer '+ self.$auth.getToken(),
                                        }
                                }).then(response => {
                                    let data = response.data.data;
                                    data.map((item, index) => {
                                        item.value = item.geonameId;
                                        item.label = item.toponymName;
                                        if(item.geonameId == self.doctor.region_id){
                                            self.doctor.region.label = item.toponymName;
                                            self.doctor.region.value = item.geonameId;
                                            self.$http.post(public_api.api.cities, {region: self.doctor.region.value})
                                                .then(response => {
                                                    let data = response.data.data;
                                                    data.map(_item => {
                                                        _item.value = _item.geonameId
                                                        _item.label = _item.toponymName
                                                        if(_item.toponymName == self.doctor.comunity){
                                                            self.doctor.city.label = _item.toponymName;
                                                            self.doctor.city.value = _item.geonameId;
                                                        }
                                                    })
                                                    self.cities = data;
                                                })
                                        }
                                    });
                                    // storage comunities
                                    self.regions = data;
                                }).catch(error => {
                                    console.log(error);
                                    //alert("No se pudo cargar las comunidades");
                                });
                        }
                        self.$http.get('/specialities?country='+self.$route.params.country)
		                .then(response => {
		                    if(response.data.status == "OK"){
		                        self.specialities = response.data.data;
		                        self.doctor.specialities.forEach( speciality => {
	                            self.specialities.find( _speciality  => {
	                                if (speciality.id == _speciality.id){
	                                    _speciality.checked = true;
	                                    return false;
	                                }
	                            	});
	                        	});
		                    }
		                });
                    }
                });
        },
        computed: {
            filteredSpecialities(){
       			let self = this;
        		return this.specialities.filter(specialty => {
			      return specialty.name.toLowerCase().indexOf(self.filterSpecialities) >= 0;      
			    })
        	},
            // Get Language
            translate(){
                return this.$store.getters.language.app[this.lang].prestador;
            },
            // Get lang
            lang(){
                return this.$store.getters.language.lang;
            }
        },
        methods: {
            // Signin success
            onSignInSuccess (res) {
                if(res.status == "connected"){
                    this.fbStatus = 1;
                    this.FacebookGetPages();
                }
            },
            // Facebook getPages
            FacebookGetPages(){
                var self = this;
                FB.api('/me/accounts', function (res) {
                    self.fbPages = res.data;
                    if(self.fbStatus == 3){
                        var found = false;
                        self.fbPages.forEach(function(v, index){
                            if(self.fbPages[index].id == self.fbPageData.id){
                                self.fbPageData.token = self.fbPages[index].access_token;
                                found = true;
                            }
                        })
                        if(found){
                            self.updateFacebookData();
                        } else {
                            self.removeFacebookData();
                        }
                    }
                    console.log(res)
                });
            },
            // Select page from facebook
            FacebookSelectPage(page){
                if(this.fbWorking) return;
                this.fbPageData = {id:page.id, token: page.access_token, name: page.name};
                this.fbStatus = 2;
                console.log(page);
            },
            // Crete tab to facebook
            FacebookCreateTab() {
                var self = this;
                if(self.fbWorking) return;
                self.fbWorking = true;
                var url = '/'+self.fbPageData.id+'/tabs';
                var data = {app_id: self.appID, access_token: self.fbPageData.token, position:1};
                FB.api(url, 'post', data, function (res) {
                    self.fbWorking = false;
                    if(res.success && res.success == true){
                        self.fbStatus = 3;
                        self.updateFacebookData();
                    } else {
                        self.fbStatus = 4;

                    }
                    console.log(res);
                });
            },
            // Remove tab to facebook
            FacebookRemoveTab() {
                var self = this;
                if(self.fbWorking) return;
                self.fbWorking = true;
                var url = '/'+self.fbPageData.id+'/tabs';
                var data = {tab: 'app_'+self.appID, access_token: self.fbPageData.token};
                FB.api(url, 'delete', data, function (res) {
                    self.fbWorking = false;
                    if(res.success && res.success == true){
                        self.fbStatus = 0;
                        self.removeFacebookData();
                    } else {
                        self.fbStatus = 4;
                    }
                    console.log(res);
                });
            },
            // Update facebook data
            updateFacebookData(){
                this.$http.post(doctor.api.facebook, this.fbPageData, {
                                headers: {
                                    Authorization : 'Bearer '+ this.$auth.getToken(),
                                }
                        }).then(response => {
                            let data = response.data.data;
                            console.log(data)
                        })
            },
            // Remove facebook data
            removeFacebookData(){
                this.$http.delete(doctor.api.facebook, {
                                headers: {
                                    Authorization : 'Bearer '+ this.$auth.getToken(),
                                }
                        }).then(response => {
                            let data = response.data.data;
                            console.log(data)
                        })
            },
            // Sngin error facebook
            onSignInError (error) {
              console.log('OH NOES', error)
            },
            // Open Modal
            openDialog(ref) {
                this.$refs[ref].open();
            },
            // Close Modal
            closeDialog(ref) {
                this.$refs[ref].close();
                self.alert.msg = '';
            },
            onOpen() {
                console.log('Opened');
            },
            onClose(type) {
                console.log('Closed', type);
            },
            // Send profile doctor
            submit(){
                this.process = true;
                this.$http.put('/admin/doctor/'+ this.doctor.id, this.doctor, {
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                    })
                    .then(response => {
                        this.process = false;
                        if(response.data.status == "OK"){
                            self.data.confirmation.isSuccess = true;
                            self.data.confirmation.isError   = false;
                            self.alert.msg = response.data.msg;
                        }else{
                            self.data.confirmation.isSuccess = false;
                            self.data.confirmation.isError   = true;
                            self.alert.msg = response.data.msg;
                        }
                        this.openDialog('dialog1');
                    }).catch(error => {
                        this.process = false;
                        console.log(error);
                    });
            },
            // On chose by speciality
            onChosen(add, speciality_id){
                if(add){
                    this.specialities.find( speciality  => {
                        if (speciality.id == speciality_id){
                            speciality.checked = true;
                        }
                    });
                    this.doctor.specialities.push({"id": speciality_id});
                }else{
                    this.specialities.find( speciality  => {
                        if (speciality.id == speciality_id){
                            speciality.checked = false;
                        }
                    });
                    this.doctor.specialities.find( (speciality, index) => {
                        if (speciality.id == speciality_id){
                            this.doctor.specialities.splice(index,1);
                            return false;
                        }
                    });
                }
            },
            // Upload avatar
            uploadAvatarIcon(e){
                let icon = document.getElementById('fileAvatar');
                icon.click();
            },
            // Change avatar
            onAvatarChange(e) {
              this.errors.formAvatar = "";
              let formAvatar = document.getElementById('formAvatar');
              console.log(formAvatar);
              var weight = formAvatar.fileAvatar.files[0] ? ((formAvatar.fileAvatar.files[0].size / 1024) / 1024) : 0;
              if(weight >=1){
                this.errors.formAvatar = "Imagen pesa demasiado, limite 1MB";
                return;
              }
              let formData = new FormData(formAvatar);
              let url = this.route.doctor.api.upload.avatar;
              let self = this;
              this.process = true;
              this.$http.post(url, formData, {
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                    })
                    .then(response => {
                        this.process = false;
                        if(response.data.status == "OK"){
                            self.profile_image = response.data.data.image;

                        }else{
                            self.profile_image = "https://api.agendaenlinea.cl/image/default_avatar.png";
                        }
                        self.data.activeTab = 1;
                        self.$store.dispatch('setAvatar', self.profile_image);
                    }).catch(error => {
                        this.process = false;
                        console.log("Catch");
                        if(error.response){
                            if(error.response.status = 422){
                                // this.setErrors(error.response.data);
                            }
                        }
                    });
            },
            // Change region
            changeRegion(value){
                if(value){
                    let region = this.regions.find(item => {
                        return item.geonameId == value.geonameId})
                    if(region){
                        this.doctor.region_id = region.geonameId;
                        this.doctor.region.value = region.geonameId;
                        this.doctor.region.label = region.toponymName;
                        this.$http.post(public_api.api.cities, {region: this.doctor.region.value})
                            .then(response => {
                                let data = response.data.data
                                data.map(item => {
                                    item.value = item.geonameId
                                    item.label = item.toponymName
                                })
                                this.cities = data;
                                this.doctor.city.label = '';
                                this.doctor.city.value = '';
                            })
                    }
                }else{
                    this.cities = []
                }
            },
            // Change city
            changeCity(value) {
                if(value){
                    if(typeof value != 'string'){
                        let city = this.cities.find(item => {
                            return item.geonameId == value.geonameId})
                        this.doctor.city.label = city.label
                        this.doctor.city.value = city.value
                        this.doctor.comunity = city.label
                    }
                }
            },
        }
    }

</script>
<style>
    .fb-signin-button {
        /* This is where you control how the button looks. Be creative! */
        display: inline-block;
        padding: 8px 8px;
        border-radius: 3px;
        background-color: #4267b2;
        color: #fff;
        cursor: pointer;
    }
    .fbintegration li.md-list-item {
        border: 0.5px solid #d2c9c9;
    }
    </style>
<style lang="stylus" scoped>
    @import '../../assets/styles/variables/color.styl'
    @import '../../assets/styles/boots.styl'
    @import '../../assets/styles/common.styl'
    .multiple
        border 1px solid color_form_border
        border-radius 5px
        width 100%
        .title
            margin 0.5em
            color color_form_placeholder
        .select
            overflow-y scroll
            overflow-x hidden
            margin 0.25em
            height 110px
            .option
                width 95%
                margin 0.25em
    .subtitle
        margin-top .5em
        color color_form_placeholder
    .mar-top-1
        margin-top 1em
    .mar-top-2
        margin-top 2em
    .row
        margin 0
        padding .5em
    @import '../../assets/styles/responsive.styl'
</style>


// WEBPACK FOOTER //
// ProfilePatient.vue?78f64120